import axios from 'axios';

const initBackendApi = () => {
  const baseURL = process.env.BACKEND_API_URL;
  const apiKey = process.env.BACKEND_API_KEY;
  
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'test' && process.env.BACKEND_MOCK !== 'true') {
    if (!baseURL) console.error('Environment variable `BACKEND_API_URL` not present. Backend will not be accessible.');
    if (!apiKey) console.warn(
      'Environment variable `BACKEND_API_KEY` not present. AWS backend will not be accessible, but '
      + 'local backends will be unaffected.',
    );
  }

  const instance = axios.create({
    baseURL,
  });
  instance.defaults.headers.common['X-Api-Key'] = apiKey || '';
  instance.defaults.headers.post['Content-Type'] = 'text/plain';
  instance.defaults.headers.put['Content-Type'] = 'text/plain';
  return instance;
};

const backendService = initBackendApi();

export default backendService;
